// extracted by mini-css-extract-plugin
module.exports = {"searchSuggestionsRoot":"OJZcFmBI","categoryTitle":"hht9X86P","keywordButton":"tCt8yUgl","label":"psyoSyCK"};